// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-wrapper {
  height: 100vh;
}
.page-wrapper .page-content {
  display: inline-block;
  width: 100%;
  padding-top: 0px;
  transition: padding-left 0.3s ease;
}
@media screen and (min-width: 768px) {
  .page-wrapper .page-content {
    padding-left: 210px;
  }
}
.page-wrapper .page-content .overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 998;
  background: #000;
  opacity: 0.5;
  display: none;
}
@media screen and (max-width: 768px) {
  .page-wrapper .page-content .overlay.show {
    display: block;
  }
}
.page-wrapper .sidebar {
  left: 0px;
}
.page-wrapper.toggled .page-content {
  padding-left: 0;
}
.page-wrapper .attribution {
  position: fixed;
  bottom: 0;
  right: 0;
  padding: 5px;
  margin: 5px;
  letter-spacing: 1px;
}`, "",{"version":3,"sources":["webpack://./src/app/componentes/inicio/inicio.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACE;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kCAAA;AACJ;AACI;EANF;IAOI,mBAAA;EAEJ;AACF;AAAI;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;AAEN;AAEQ;EAFF;IAGI,cAAA;EACR;AACF;AAIE;EACE,SAAA;AAFJ;AAOI;EACE,eAAA;AALN;AASE;EACE,eAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AAPJ","sourcesContent":[".page-wrapper {\r\n  height: 100vh;\r\n\r\n  .page-content {\r\n    display: inline-block;\r\n    width: 100%;\r\n    padding-top: 0px;\r\n    transition: padding-left .3s ease;\r\n\r\n    @media screen and (min-width: 768px) {\r\n      padding-left: 210px;\r\n    }\r\n\r\n    .overlay {\r\n      position: fixed;\r\n      top: 0;\r\n      right: 0;\r\n      bottom: 0;\r\n      left: 0;\r\n      z-index: 998;\r\n      background: #000;\r\n      opacity: .5;\r\n      display: none;\r\n\r\n      &.show {\r\n\r\n        @media screen and (max-width: 768px) {\r\n          display: block;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .sidebar {\r\n    left: 0px;\r\n  }\r\n\r\n  &.toggled {\r\n\r\n    .page-content {\r\n      padding-left: 0;\r\n    }\r\n  }\r\n\r\n  .attribution{\r\n    position: fixed;\r\n    bottom: 0;\r\n    right: 0;\r\n    padding: 5px;\r\n    margin: 5px;\r\n    letter-spacing: 1px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
